export const TOKEN_EXPIRED_EVENT = 'tokenExpired';

export type FetchStatus = 'preparing' | 'fetching' | 'fetched' | 'errored';
